export enum BlockActionType {
    LINK = 'link',
    NEXTPAGE = 'nextPage',
    CONNECTEDPAGE = 'connectedPage',
  }